import { type IconType } from "@jsq/ds/icons";
import { PAYMENT_METHOD_ICON } from "../../common/constants";
import {
  type DetailedPaymentPrefUnionObjectType,
  type RedactedPaymentPref,
} from "../../common/types";
import { getPaymentMethod } from "../../common/utils";

export const getPaymentMethodIconType = (
  paymentPref: DetailedPaymentPrefUnionObjectType | RedactedPaymentPref,
): IconType => {
  return PAYMENT_METHOD_ICON[getPaymentMethod(paymentPref)];
};
